import React from 'react';
import { withTranslation } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import isNumber from 'is-number';
import { Dialog } from '@material-ui/core';
import { compose } from 'recompose';

import { Box, Flex, ButtonFilled, ButtonText, Text, Image, SvgIcon } from '../../../Base';

const ProgressDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 16px;
  }
`;

/**
 * @description
 * Convert seconds to time format(H.mm.ss)
 * it will return string as {mm.ss} if time is less than 3600(1hr)
 * @example
 * // return 0.50
 * convertToStartAtTimestamp(50)
 * @example
 * // return 3.05
 * convertToStartAtTimestamp(185)
 * @example
 * // return 5.00.30
 * convertToStartAtTimestamp(18030)
 * @param {number} time time in seconds
 * @returns {string} converted time string in format(H.mm.ss)
 */
const convertToStartAtTimestamp = (time) => {
  if (isNumber(time)) {
    if (time >= 0) {
      const totalMinutes = time / 60;
      const hours = Math.floor(totalMinutes / 60);
      const minute = Math.floor(totalMinutes % 60);
      const seconds = Math.floor(time % 60);

      const hourString = hours === 0 ? `00` : `${hours}`;
      const minuteString = `${minute}`.toString().padStart(2, '0');
      const secondString = `${seconds}`.toString().padStart(2, '0');

      return `${hourString}.${minuteString}.${secondString}`.replace(/^0(?:0.0?)/g, '');
    } else {
      return `0.00`;
    }
  }
  return null;
};

const ResumeClassroomDialogView = ({
  open,
  course,
  bookmarkProgress,
  onConfirm,
  onCancel,
  t,
  theme: { colors = {} } = {},
}) => {
  const { courseSubTitle, courseTitle } = course;
  const { subSectionTitle, videoTime } = bookmarkProgress;
  return (
    <ProgressDialog open={open} disableBackdropClick={true} fullWidth={true} maxWidth={'xs'}>
      <Flex flexDirection={'column'} alignItems={'center'} px={7} pt={[8, 4]} pb={4}>
        <SvgIcon
          icon={SvgIcon.ICON_LIST.CLOSE}
          size={28}
          style={{ position: 'absolute', top: '29px', right: '29px', cursor: 'pointer' }}
          onClick={onCancel}
        />
        <Image src={'/assets/images/classroom/classroom-resume.svg'} mb={5} width={'82px'} />
        <Text textStyle={'heading2'} fontWeight={'light'} mb={5} textAlign="center">
          {t('RESUME.TITLE')}
        </Text>
        <Box mb={3} p="sm" bg={colors.greyscale.grey5} style={{ borderRadius: '8px' }}>
          <Text textStyle={'bold'}>{courseSubTitle}</Text>
          <Text textStyle={'bold'}>{courseTitle}</Text>
        </Box>
        <Box py={3}>
          <Text>{subSectionTitle}</Text>
          <Text>
            {t('RESUME.CAPTION_TIME', {
              videoTime: convertToStartAtTimestamp(videoTime),
            })}
          </Text>
        </Box>
        <Box width={'100%'} mt={3} style={{ borderTop: `1px solid ${colors.greyscale.grey4}` }}>
          <Text mt={7} textAlign="center">
            {t('RESUME.QUESTION.FIRST')}
          </Text>
          <Text textAlign="center">{t('RESUME.QUESTION.SECOND')}</Text>
          <ButtonFilled mt={7} mb={2} width={'100%'} fontWeight={'light'} onClick={onConfirm}>
            {t('RESUME.BUTTON_RESUME')}
          </ButtonFilled>
          <ButtonText width={'100%'} fontWeight={'light'} onClick={onCancel}>
            {t('RESUME.BUTTON_NO')}
          </ButtonText>
        </Box>
      </Flex>
    </ProgressDialog>
  );
};
export default compose(withTheme, withTranslation('classroom'))(ResumeClassroomDialogView);
